
// 用户缓存
export const saveUser = (userInfo: any) =>{
  userInfo.saveStoreTime = new Date()
  localStorage.setItem("userInfo",JSON.stringify(userInfo))
}

export const getUser = () => {
  const userInfo = localStorage.getItem("userInfo")
  if(userInfo == null){
    return {}
  }
  return JSON.parse(userInfo)
}